import { Navigate, useLocation } from 'react-router';
import { carryReceiveLink } from '@admin-panel/providers/lib/authSession';

/**
 * Refine's CatchAllNavigate for signed-out visitors, plus the receive link's parcel. A rider's
 * handover QR opens `/receive#w=…&c=…`; CatchAllNavigate keeps only path and query, so a signed-out
 * phone would land on Home after login. The login URL carries the parcel only: its code waits in
 * this tab's sessionStorage, because the login URL's query reaches servers and their logs.
 */
export const LoginNavigate = ({ to }: { to: string }) => {
  const { pathname, search, hash } = useLocation();
  const destination = carryReceiveLink(pathname, hash) ?? `${pathname}${search}`;
  const query = destination.length > 1 ? `?to=${encodeURIComponent(destination)}` : '';
  return <Navigate to={`${to}${query}`} />;
};
